export const TaxRegistrationStatus = {
    Started: 'Started',
    Submitted: 'Submitted',
    Complete: 'Complete',
    Cancelled: 'Cancelled',
    InformationRequested: 'InformationRequested',
} as const

export type TaxRegistrationStatusType = (typeof TaxRegistrationStatus)[keyof typeof TaxRegistrationStatus]

export interface TaxRegistrationDTO {
    userId: number
    accountantId: number | null
    status: TaxRegistrationStatusType
    statusChangedDateUTC: string
    additionalNotes: string
}

export const TaxRegistrationStatusOrder: Record<TaxRegistrationStatusType, number> = {
    [TaxRegistrationStatus.Started]: 0,
    [TaxRegistrationStatus.Submitted]: 10,
    [TaxRegistrationStatus.InformationRequested]: 15,
    [TaxRegistrationStatus.Complete]: 20,
    [TaxRegistrationStatus.Cancelled]: 30,
}
